import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text, Pressable
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomText from "components/base/CustomText";

interface ArgsType {
    vmId: string;
    vmName: string;
    projectId: string;
    projectName: string;
}

interface BackupAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: ArgsType,
};

BackupAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function BackupAdd(props:BackupAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);

    // 기본정보
    const [backupName, setBackupName] = useState("");
    const [backupDescription, setBackupDescription] = useState("");
    // Alert
    const [backupNameWarnYn, setBackupNameWarnYn] = useState(false);

    const [projectList, setProjectList] = useState<DropdownType[]>([{ value: "", label: t("EMPTY_TEXT")}]);
    const [projectId, setProjectId] = useState("");


    const [vmList, setVmList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [vmId, setVmId] = useState("");


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(stepIndex === 0) {
            if(!props.args?.projectId) {
                loadProjectList();
            }
        }
    }, [stepIndex])

    useEffect(() => {
        if(props.args && props.args.vmId) {
            setProjectId(props.args.projectId);
            setProjectList([{value: props.args.projectId, label: props.args.projectName}]);
            setVmList([{value: props.args.vmId, label: props.args.vmName}]);
            setVmId(props.args.vmId);
        }
    }, [props.args])

    useEffect(() => {
        if(projectId && !props.args?.vmId) {
            loadVmList();
        }
    }, [projectId]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(checkBackupData()) {
                setExecuteAddYn(true);
            } else {
                executeResult({successYn: false}, false, '');
            }
        }
    }, [props.clickedConfirmYn]);



    useEffect(() => {
        if(executeAddYn) {
            executeAddBackupImage();
        }
    }, [executeAddYn]);

    function checkBackupData() {
        setBackupNameWarnYn(false);
        let message = '';
        let error = false;
        if(!backupName) {
            message = t("VM_BACKUP_NEED_BASIC_INFO");
            setBackupNameWarnYn(true);
            error = true;
        }
        if(!projectId || !vmId) {
            message = t("VM_BACKUP_NEED_BASIC_INFO");
            error = true;
        }
        if(error === true) {
            executeResult({}, false, message);
        }
        return !error;
    }

    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }


    function loadVmList() {
    
        requests.get(PLATFORM_URL.PROJECT + '/' + projectId + PLATFORM_URL.VM, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data) {
                setVmList(response.data.items.map((data, index) => {
                    if (data.vm_status_code !== 'ACT' && data.vm_status_code !== 'SOFF' && data.vm_status_code !== 'PAUSE' && data.vm_status_code !== 'SUSP')
                        return false;
                    if (data.vm_type_code === 'CONTNODE')
                        return false;
                    return { value: data.vm_id, label: data.vm_name };
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }



    // TODO API에 따라 URL 및 Data 수정
    function executeAddBackupImage() {
        const body = {};

        body['vm'] = {
            vm_id: vmId,
        }
        body['vm_backup'] = {
            vm_backup_name: backupName,
            vm_backup_description: backupDescription
        }
        body['project'] = {
            project_id: projectId
        }


        requests.post(PLATFORM_URL.VM_BACKUP, body)
        .then((response) => {
            executeResult({successYn: true }, true, "");
        })
        .catch((error) => {
            if(props.showMessageCb) {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    // 프로젝트 옵션리스트 조회
    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT, {size: 9999})
        .then((response) => {
            setProjectList(response.data.items?.map((data, index) => {
                return {
                    value: data.project_id,
                    label: data.project_name
                }
            }));
        })
        .catch((error) => {
            if(props.showMessageCb) {
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("BACKUP_IMAGE_CREATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_BACKUP_IMAGE_NAME")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput
                                key={1}
                                width={560} height={36}
                                value={backupName}
                                type={"text"}
                                activeYn={true}
                                inputCb={setBackupName}
                                warnYn={backupNameWarnYn}
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("VM_BACKUP_IMAGE_DESC")}
                            </Text>
                            <TextArea
                                key={2}
                                width={570} height={100}
                                value={backupDescription}
                                type={"text"}
                                activeYn={true}
                                inputCb={setBackupDescription}
                                warnYn={false}
                                placeHolderText={t("DESCRIPTION_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("PROJECT_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={48}
                                width={560} height={36}
                                items={projectList}
                                value={projectId}
                                setValue={setProjectId}
                                disable={props.args?.projectId ? true : false}
                                defaultvalue={props.args?.projectId ? {value: props.args?.projectId, label: props.args?.projectName} : {value: "", label: ""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("VM_BACKUP_TARGET_VM")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown
                                key={7}
                                width={300} height={36}
                                items={vmList}
                                setValue={setVmId}
                                disable={props.args?.vmId ? true : false}
                                defaultvalue={props.args?.vmId ? {value: props.args.vmId, label: props.args.vmName} : {value: "", label: ""}}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                    </View>
                </View>
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    requireText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#e86045"
    },
    infoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    }
});